import VueRouter from 'vue-router'

import NProgress from 'nprogress'
NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })


//import login from './components/Login.vue'
// import main from './components/layout/Layout.vue'
// import notfound from './components/errorpage/NotFound.vue'
// import welcome from './components/welcome/Welcome.vue'
// import adminlist from './components/adminmanage/AdminList.vue'
// import rolelist from './components/adminmanage/RoleList.vue'
const home = () =>
    import( /* webpackChunkName: "login_404" */ './components/home/index.vue')

const login = () =>
    import ( /* webpackChunkName: "login_404" */ './components/Login.vue')
const main = () =>
    import ( /* webpackChunkName: "main_wel" */ './components/layout/Layout.vue')
const notfound = () =>
    import ( /* webpackChunkName: "login_404" */ './components/errorpage/NotFound.vue')
const welcome = () =>
    import ( /* webpackChunkName: "main_wel" */ './components/welcome/WelcomeTwo.vue')
const adminlist = () =>
    import ( /* webpackChunkName: "admin_role" */ './components/adminmanage/AdminList.vue')
// const rolelist = () =>
//     import ( /* webpackChunkName: "admin_role" */ './components/adminmanage/RoleList.vue')
const rolelist = () =>
    import ( /* webpackChunkName: "admin_role" */ './components/adminmanage/SecondRoleList.vue')
const welcomenoticelist = () =>
    import ( /* webpackChunkName: "main_wel" */ './components/welcome/Welcomenoticelist.vue')




//系统设置
// const rateSettingList = () =>
//     import ( /* webpackChunkName: "sys" */ './components/systemmange/RateSettingList.vue')
const systemMessageInfoList = () =>
    import ( /* webpackChunkName: "sys" */ './components/systemmange/SystemMessageInfoList.vue')
const SuLogList = () =>
    import( /* webpackChunkName: "sys" */ './components/systemmange/SuLogList.vue')
const Regionlist = () =>
    import( /* webpackChunkName: "sys" */ './components/systemmange/Regionlist.vue')
const CompilationOfPolicyMeasures = () =>
    import( /* webpackChunkName: "sys" */ './components/systemmange/CompilationOfPolicyMeasures.vue')
const noticeList = () =>
    import( /* webpackChunkName: "sys_y" */ './components/systemmange/NoticeList.vue')
const getexplainsettinglistbypage = () =>
    import( /* webpackChunkName: "sys_y" */ './components/systemmange/Explainset.vue')
const advertising = () =>
    import( /* webpackChunkName: "sys" */ './components/systemmange/Advertising.vue')   
const biztimesetlist = () =>
    import( /* webpackChunkName: "sys" */ './components/systemmange/Biztimesetlist.vue')   
let sysTitle = '管理系统'

//新城镇奖扶
const townacceptapplylist = () =>
    import( /* webpackChunkName: "town_apply" */ './components/townawardmanagetwo/acceptmanage/TownAcceptApplyList.vue')
const townrewarannualreviewuserlist = () =>
    import( /* webpackChunkName: "town_award" */ './components/townawardmanagetwo/year/TownRewarAnnualreviewUserList.vue')
const townrewardrecordinfolist = () =>
    import( /* webpackChunkName: "town_award_file" */ './components/townawardmanagetwo/filemanage/TownRewardRecordInfoList.vue')
const TownApplyAuditUserList = () =>
    import( /* webpackChunkName: "town_publicity" */ './components/townawardmanagetwo/publicity/TownApplyAuditUserList.vue')
const townmoveoutrewardrecordinfolist = () =>
    import( /* webpackChunkName: "town_award_file" */ './components/townawardmanagetwo/filemanage/TownMoveOutRewardRecordInfoList.vue')
const townmoveinrewardrecordinfolist = () =>
    import( /* webpackChunkName: "town_award_file" */ './components/townawardmanagetwo/filemanage/TownMoveInRewardRecordInfoList.vue')
const TownMoveOutQueryRecordList = () =>
    import( /* webpackChunkName: "town_award_file" */ './components/townawardmanagetwo/filemanage/TownMoveOutQueryRecordList.vue')

//城镇奖扶
// const townacceptapplylist = () =>
//     import( /* webpackChunkName: "town_apply" */ './components/townawardmanage/acceptmanage/TownAcceptApplyList.vue')
// const townaddpolicydeclarationinfo = () =>
//     import( /* webpackChunkName: "town_apply" */ './components/townawardmanage/TownAddPolicyDeclarationInfo.vue')
const townapplyauditfaileduserlist = () =>
    import( /* webpackChunkName: "town_apply" */ './components/townawardmanage/TownApplyAuditFailedUserList.vue')
const townapplyauditvillage1userlist = () =>
    import( /* webpackChunkName: "town_award" */ './components/townawardmanage/villagemanage/TownApplyAuditvillage1UserList.vue')
const townapplyaudit1userlist003 = () =>
    import( /* webpackChunkName: "town_award" */ './components/townawardmanage/TownApplyAudit1UserList.vue')
 const townapplyauditvillage2userlist = () =>
    import( /* webpackChunkName: "town_award" */ './components/townawardmanage/villagemanage/TownApplyAuditvillage2UserList.vue')
// const townrewardrecordinfolist = () =>
//     import( /* webpackChunkName: "town_award_file" */ './components/townawardmanage/filemanage/TownRewardRecordInfoList.vue')
const townlogoutrewardrecordinfolist = () =>
    import( /* webpackChunkName: "town_award_file" */ './components/townawardmanage/filemanage/TownLogoutRewardRecordInfoList.vue')
// const townmoveinrewardrecordinfolist = () =>
//     import( /* webpackChunkName: "town_award_file" */ './components/townawardmanage/filemanage/TownMoveInRewardRecordInfoList.vue')
// const townmoveoutrewardrecordinfolist = () =>
//     import( /* webpackChunkName: "town_award_file" */ './components/townawardmanage/filemanage/TownMoveOutRewardRecordInfoList.vue')
// const townrewarannualreviewuserlist = () =>
//     import( /* webpackChunkName: "town_award" */ './components/townawardmanage/TownRewarAnnualreviewUserList.vue')
const townapplyauditfinishuserlist = () =>
    import( /* webpackChunkName: "town_award" */ './components/townawardmanage/TownApplyAuditFinishUserList.vue')
const townqueryapplyauditlist = () =>
    import( /* webpackChunkName: "town_award_search" */ './components/townawardmanage/searchmanage/TownQueryApplyAuditList.vue')
const townqueryrewardauditlist = () =>
    import( /* webpackChunkName: "town_award_search" */ './components/townawardmanage/searchmanage/TownQueryRewardAuditList.vue')
const townqueryrewardrecordinfolist = () =>
    import( /* webpackChunkName: "town_award_search" */ './components/townawardmanage/searchmanage/TownQueryRewardRecordInfoList.vue')
const townQueryrewardlogoutlist = () =>
    import( /* webpackChunkName: "town_award_search" */ './components/townawardmanage/searchmanage/TownQueryRewardLogoutList.vue')

//国家特扶v2
const nationacceptapplylist = () =>
    import( /* webpackChunkName: "nation_submit" */ './components/nationmanagetwo/acceptmanage/NationAcceptApplyList.vue')
const nationrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nation_file_apply" */ './components/nationmanagetwo/filemanage/NationRewardRecordInfoList.vue')
const nationmoveinrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nation_file_apply" */ './components/nationmanagetwo/filemanage/NationMoveInRewardRecordInfoList.vue')
const nationmoveoutrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nation_file_apply" */ './components/nationmanagetwo/filemanage/NationMoveOutRewardRecordInfoList.vue')
const nationrewardannualreviewuserlist = () =>
    import( /* webpackChunkName: "nation_year_apply" */ './components/nationmanagetwo/year/NationRewardAnnualreviewUserList.vue')
const NationApplyAuditUserList = () =>
    import( /* webpackChunkName: "nation_village_apply" */ './components/nationmanagetwo/publicity/NationApplyAuditUserList.vue')
    
//国家特扶
// const nationacceptapplylist = () =>
//     import( /* webpackChunkName: "nation_submit" */ './components/nationmanage/acceptmanage/NationAcceptApplyList.vue')
// const nationaddpolicydeclarationinfo = () =>
//     import( /* webpackChunkName: "nation_submit" */ './components/nationmanage/acceptmanage/NationAddPolicyDeclarationInfo.vue')
const nationapplyauditfaileduserlist = () =>
    import( /* webpackChunkName: "nation_submit" */ './components/nationmanage/NationApplyAuditFailedUserList.vue')
const nationapplyauditvillage1userlist = () =>
    import( /* webpackChunkName: "nation_village_apply" */ './components/nationmanage/villagemanage/NationApplyAuditvillage1UserList.vue')
// const nationapplyauditvillage2userlist = () =>
//     import( /* webpackChunkName: "nation_village_apply" */ './components/nationmanage/villagemanage/NationApplyAuditvillage2UserList.vue')
const nationapplyauditvillage3userlist = () =>
    import( /* webpackChunkName: "nation_village_apply" */ './components/nationmanage/villagemanage/NationApplyAuditvillage3UserList.vue')
const nationapplyauditvillage4userlist = () =>
    import( /* webpackChunkName: "nation_village_apply" */ './components/nationmanage/villagemanage/NationApplyAuditvillage4UserList.vue')
const nationapplyaudit1userlist = () =>
    import( /* webpackChunkName: "nation_twon_apply" */ './components/nationmanage/townshipmanage/NationApplyAudit1UserList.vue')
const nationapplyaudit2userlist = () =>
    import( /* webpackChunkName: "nation_twon_apply" */ './components/nationmanage/townshipmanage/NationApplyAudit2UserList.vue')
const nationapplyaudit3userlist = () =>
    import( /* webpackChunkName: "nation_twon_apply" */ './components/nationmanage/townshipmanage/NationApplyAudit3UserList.vue')
const nationapplyaudit4userlist = () =>
    import( /* webpackChunkName: "nation_twon_apply" */ './components/nationmanage/townshipmanage/NationApplyAudit4UserList.vue')
const nationapplyaudit5userlist = () =>
    import( /* webpackChunkName: "nation_district_apply" */ './components/nationmanage/districtmanage/NationApplyAudit5UserList.vue')
const nationapplyaudit6userlist = () =>
    import( /* webpackChunkName: "nation_district_apply" */ './components/nationmanage/districtmanage/NationApplyAudit6UserList.vue')
const nationapplyaudit7userlist = () =>
    import( /* webpackChunkName: "nation_district_apply" */ './components/nationmanage/districtmanage/NationApplyAudit7UserList.vue')
const nationapplyaudit8userlist = () =>
    import( /* webpackChunkName: "nation_district_apply" */ './components/nationmanage/districtmanage/NationApplyAudit8UserList.vue')
const nationapplyauditfinishuserlist = () =>
    import( /* webpackChunkName: "nation_district_apply" */ './components/nationmanage/NationApplyAuditFinishUserList.vue')
// const nationrewardannualreviewuserlist = () =>
//     import( /* webpackChunkName: "nation_year_apply" */ './components/nationmanage/annualreviewmanage/NationRewardAnnualreviewUserList.vue')
const nationrewardannualreviewfaileduserlist = () =>
    import( /* webpackChunkName: "nation_year_apply" */ './components/nationmanage/annualreviewmanage/NationRewardAnnualReviewfailedUserList.vue')
// const nationrewardrecordinfolist = () =>
//     import( /* webpackChunkName: "nation_file_apply" */ './components/nationmanage/filemanage/NationRewardRecordInfoList.vue')
const nationlogoutrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nation_file_apply" */ './components/nationmanage/filemanage/NationLogoutRewardRecordInfoList.vue')
// const nationmoveinrewardrecordinfolist = () =>
//     import( /* webpackChunkName: "nation_file_apply" */ './components/nationmanage/filemanage/NationMoveInRewardRecordInfoList.vue')
// const nationmoveoutrewardrecordinfolist = () =>
//     import( /* webpackChunkName: "nation_file_apply" */ './components/nationmanage/filemanage/NationMoveOutRewardRecordInfoList.vue')
const nationqueryapplyauditlist = () =>
    import( /* webpackChunkName: "nation_award_search" */ './components/nationmanage/searchmanage/NationQueryApplyAuditList.vue')
const nationqueryrewardauditlist = () =>
    import( /* webpackChunkName: "nation_award_search" */ './components/nationmanage/searchmanage/NationQueryRewardAuditList.vue')
const nationqueryrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nation_award_search" */ './components/nationmanage/searchmanage/NationQueryRewardRecordInfoList.vue')
const nationqueryrewardlogoutlist = () =>
    import( /* webpackChunkName: "nation_award_search" */ './components/nationmanage/searchmanage/NationQueryRewardLogoutList.vue')



//国家奖励v2
const nationawardAcceptApplyList = () =>
    import( /* webpackChunkName: "nation_award_apply" */ './components/nationawardmanagetwo/acceptmanage/NationAwardAcceptApplyList.vue')    
const nationawardrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nationaward_year_apply" */ './components/nationawardmanagetwo/filemanage/NationAwardRewardRecordInfoList.vue')
const NationAwardApplyAuditUserList = () =>
    import( /* webpackChunkName: "nation_award_village_apply" */ './components/nationawardmanagetwo/publicity/NationAwardApplyAuditUserList.vue')
const nationawardmoveinrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nationaward_file_apply" */ './components/nationawardmanagetwo/filemanage/NationAwardMoveInRewardRecordInfoList.vue')
const nationawardmoveoutrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nationaward_file_apply" */ './components/nationawardmanagetwo/filemanage/NationAwardMoveOutRewardRecordInfoList.vue')
const nationawardrewardannualreviewuserlist = () =>
    import( /* webpackChunkName: "nation_year_apply" */ './components/nationawardmanagetwo/year/NationAwardRewardAnnualReviewUserList.vue')


//国家奖励
// const nationawardAcceptApplyList = () =>
//     import( /* webpackChunkName: "nation_award_apply" */ './components/nationawardmanage/acceptmanage/NationAwardAcceptApplyList.vue')
// const nationawardaddpolicydeclarationinfo = () =>
//     import( /* webpackChunkName: "nation_award_apply" */ './components/nationawardmanage/acceptmanage/NationAwardAddPolicyDeclarationInfo.vue')
const nationawardapplyauditvillage1userlist = () =>
    import( /* webpackChunkName: "nation_award_village_apply" */ './components/nationawardmanage/villagemanage/NationAwardApplyAuditvillage1UserList.vue')
const nationawardapplyauditfaileduserlist = () =>
    import( /* webpackChunkName: "nation_award_apply" */ './components/nationawardmanage/NationAwardApplyAuditFailedUserList.vue')
// const nationawardapplyauditvillage2userlist = () =>
//     import( /* webpackChunkName: "nation_award_village_apply" */ './components/nationawardmanage/villagemanage/NationAwardApplyAuditvillage2UserList.vue')
const nationawardapplyauditvillage3userlist = () =>
    import( /* webpackChunkName: "nation_award_village_apply" */ './components/nationawardmanage/villagemanage/NationAwardApplyAuditvillage3UserList.vue')
const nationawardapplyauditvillage4userlist = () =>
    import( /* webpackChunkName: "nation_award_village_apply" */ './components/nationawardmanage/villagemanage/NationAwardApplyAuditvillage4UserList.vue')
const nationawardapplyaudit1userlist = () =>
    import( /* webpackChunkName: "nationaward_twon_apply" */ './components/nationawardmanage/townshipmanage/NationAwardApplyAudit1UserList.vue')
const nationawardapplyaudit2userlist = () =>
    import( /* webpackChunkName: "nationaward_twon_apply" */ './components/nationawardmanage/townshipmanage/NationAwardApplyAudit2UserList.vue')
const nationawardapplyaudit3userlist = () =>
    import( /* webpackChunkName: "nationaward_twon_apply" */ './components/nationawardmanage/townshipmanage/NationAwardApplyAudit3UserList.vue')
const nationawardapplyaudit4userlist = () =>
    import( /* webpackChunkName: "nationaward_twon_apply" */ './components/nationawardmanage/townshipmanage/NationAwardApplyAudit4UserList.vue')
const nationawardapplyaudit5userlist = () =>
    import( /* webpackChunkName: "nationaward_district_apply" */ './components/nationawardmanage/districtmanage/NationAwardApplyAudit5UserList.vue')
const nationawardapplyaudit6userlist = () =>
    import( /* webpackChunkName: "nationaward_district_apply" */ './components/nationawardmanage/districtmanage/NationAwardApplyAudit6UserList.vue')
const nationawardapplyaudit7userlist = () =>
    import( /* webpackChunkName: "nationaward_district_apply" */ './components/nationawardmanage/districtmanage/NationAwardApplyAudit7UserList.vue')
const nationawardapplyaudit8userlist = () =>
    import( /* webpackChunkName: "nationaward_district_apply" */ './components/nationawardmanage/districtmanage/NationAwardApplyAudit8UserList.vue')
const nationawardapplyauditfinishuserlist = () =>
    import( /* webpackChunkName: "nationaward_district_apply" */ './components/nationawardmanage/NationAwardApplyAuditFinishUserList.vue')
// const nationawardrewardannualreviewuserlist = () =>
//     import( /* webpackChunkName: "nation_year_apply" */ './components/nationawardmanage/annualreviewmanage/NationAwardRewardAnnualReviewUserList.vue')
const nationawardrewardannualreviewfaileduserlist = () =>
    import( /* webpackChunkName: "nationaward_year_apply" */ './components/nationawardmanage/annualreviewmanage/NationAwardRewardAnnualReviewFailedUserList.vue')
// const nationawardrewardrecordinfolist = () =>
//     import( /* webpackChunkName: "nationaward_year_apply" */ './components/nationawardmanage/filemanage/NationAwardRewardRecordInfoList.vue')
const nationawardlogoutrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nationaward_file_apply" */ './components/nationawardmanage/filemanage/NationAwardLogoutRewardRecordInfoList.vue')
// const nationawardmoveinrewardrecordinfolist = () =>
//     import( /* webpackChunkName: "nationaward_file_apply" */ './components/nationawardmanage/filemanage/NationAwardMoveInRewardRecordInfoList.vue')
// const nationawardmoveoutrewardrecordinfolist = () =>
//     import( /* webpackChunkName: "nationaward_file_apply" */ './components/nationawardmanage/filemanage/NationAwardMoveOutRewardRecordInfoList.vue')
const nationawardqueryapplyauditlist = () =>
    import( /* webpackChunkName: "nationaward_search" */ './components/nationawardmanage/searchmanage/NationAwardQueryApplyAuditList.vue')
// const nationawardqueryrewardauditlist = () =>
//     import( /* webpackChunkName: "nationaward_search" */ './components/nationawardmanage/searchmanage/NationAwardQueryRewardAuditList.vue')
const nationawardqueryrewardrecordinfolist = () =>
    import( /* webpackChunkName: "nationaward_search" */ './components/nationawardmanage/searchmanage/NationAwardQueryRewardRecordInfoList.vue')
const nationawardqueryrewardlogoutlist = () =>
    import( /* webpackChunkName: "nationaward_search" */ './components/nationawardmanage/searchmanage/NationAwardQueryRewardLogoutList.vue')

//信息查询
const QueryRewardAuditList = () =>
    import( /* webpackChunkName: "search" */ './components/searchtwo/QueryRewardAuditList.vue')
const QueryRewardRecordInfoList = () =>
    import( /* webpackChunkName: "search" */ './components/searchtwo/QueryRewardRecordInfoList.vue')
const QueryApplyAuditList = () =>
    import( /* webpackChunkName: "search" */ './components/searchtwo/QueryApplyAuditList.vue')

    
    
//审核申报
const applyauditlist = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyauditlist.vue')
const applyaudit2list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit2list.vue')
const applyaudit3list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit3list.vue')
const applyaudit4list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit4list.vue')
const applyaudit5list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit5list.vue')
const applyaudit6list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit6list.vue')
const applyaudit7list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit7list.vue')
const applyaudit8list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit8list.vue')
const applyaudit9list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit9list.vue')    
const applyaudit10list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit10list.vue')
const applyaudit11list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit11list.vue')
const applyaudit12list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit12list.vue')
const applyaudit13list = () =>
    import( /* webpackChunkName: "apply" */ './components/applicationreview/applyaudit13list.vue')   
//政策措施汇编
const FundProportion = () =>
    import ( /* webpackChunkName: "sys" */ './components/policycompilationmanage/FundProportion.vue')
const PolicyCompilation = () =>
    import ( /* webpackChunkName: "sys" */ './components/policycompilationmanage/PolicyCompilation.vue')
  
// const windowtoaccept = () =>
//     import ( /* webpackChunkName: "win" */ './components/windowtoaccept/Windowtoaccept.vue')
const applyauditfailedlist = () =>
    import ( /* webpackChunkName: "win" */ './components/windowtoaccept/applyauditfailedlist.vue')
const iscarefulreview = () =>
    import ( /* webpackChunkName: "win" */ './components/windowtoaccept/Iscarefulreview.vue')

//档案管理
const awardObjectFile = () =>
    import ( /* webpackChunkName: "file" */ './components/filemanage/awardObjectFile.vue')
const exitObjectFileList = () =>
    import ( /* webpackChunkName: "file" */ './components/filemanage/exitObjectFileList.vue')
const immigrationlist = () =>
    import ( /* webpackChunkName: "file" */ './components/filemanage/immigrationList.vue')
const emigrationlist = () =>
    import ( /* webpackChunkName: "file" */ './components/filemanage/emigrationList.vue')
const userlist = () =>
    import ( /* webpackChunkName: "file" */ './components/filemanage/userlist.vue')
    
    
//年审审核 
const carefulreview = () =>
    import ( /* webpackChunkName: "care" */ './components/carefulreview/Carefulreview.vue')

// 查询
const annuallist = () =>
     import ( /* webpackChunkName: "about" */ './components/aboutage/annuallist.vue')
const awardobject = () =>
     import ( /* webpackChunkName: "about" */ './components/aboutage/awardobject.vue')
const declarelist = () =>
     import ( /* webpackChunkName: "about" */ './components/aboutage/declarelist.vue')
const exitobjectlist = () =>
     import ( /* webpackChunkName: "about" */ './components/aboutage/exitobjectlist.vue')
const policymeasurelist = () =>  
     import ( /* webpackChunkName: "about" */ './components/aboutage/policymeasurelist.vue') 
 //报表         
const statisticsvillagerewardinfolist = () =>  
     import ( /* webpackChunkName: "about" */ './components/organalysis/statisticsvillagerewardinfolist.vue')       
const statisticsvillagerewarddetailslist = () =>  
     import ( /* webpackChunkName: "about" */ './components/organalysis/statisticsvillagerewarddetailslist.vue')   
const statisticstownrewardinfoexitlist = () =>  
     import ( /* webpackChunkName: "about" */ './components/organalysis/statisticstownrewardinfoexitlist.vue') 
const statisticstownrewardinfopeoplelist = () =>  
     import ( /* webpackChunkName: "about" */ './components/organalysis/statisticstownrewardinfopeoplelistnew.vue')     
const statisticsspecialassistanceinfolist = () =>  
     import ( /* webpackChunkName: "about" */ './components/organalysis/statisticsspecialassistanceinfolist.vue')    
const statisticsspecialassistanceinforenewlist = () =>  
     import ( /* webpackChunkName: "about" */ './components/organalysis/statisticsspecialassistanceinforenewlist.vue')         
var router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/login',
            meta: { title: sysTitle }
        },
        {
            path: '/main',
            component: main,
            redirect: '/welcome',
            meta: { title: '欢迎' + '-' + sysTitle },
            children: [
                { path: '/welcome', component: welcome, meta: { title: '欢迎' + '-' + sysTitle } },
                { path: '/newadminlist', component: adminlist, meta: { title: '管理员信息' + '-' + sysTitle } },
                { path: '/rolelist', component: rolelist, meta: { title: '角色信息' + '-' + sysTitle } },
                { path: '/noticeinfolist', component: noticeList, meta: { title: '公告管理' + '-' + sysTitle } },
                { path: '/systemmessageinfolist', component: systemMessageInfoList, meta: { title: '系统消息管理' + '-' + sysTitle } },
                { path: '/loginfolist', component: SuLogList, meta: { title: '日志管理' + '-' + sysTitle } },
                { path: '/regioninfolist', component: Regionlist, meta: { title: '行政区划管理' + '-' + sysTitle } },
                { path: '/systemcodeinfolist', component: CompilationOfPolicyMeasures, meta: { title: '系统编码管理' + '-' + sysTitle } },
                { path: '/biztimesetlist', component: biztimesetlist, meta: { title: '业务时间设置' + '-' + sysTitle } },
                
                //{ path: '/getexplainsettinglistbypage', component: getexplainsettinglistbypage, meta: { title: '说明设置' + '-' + sysTitle } },
                { path: '/policymeasureinfolist', component: PolicyCompilation, meta: { title: '政策措施管理' + '-' + sysTitle } },
                { path: '/fundsallocationllist', component: FundProportion, meta: { title: '资金比例管理' + '-' + sysTitle } },
                // { path: '/addpolicydeclarationinfo', component: windowtoaccept, meta: { title: '窗口管理' + '-' + sysTitle } },
                { path: '/applyauditvillage1list', component: applyaudit10list, meta: { title: '村级待审核' + '-' + sysTitle } },
                { path: '/applyauditvillage2list', component: applyaudit11list, meta: { title: '村级待提交' + '-' + sysTitle } },
                { path: '/applyauditvillage3list', component: applyaudit12list, meta: { title: '村级待审核' + '-' + sysTitle } },
                { path: '/applyauditvillage4list', component: applyaudit13list, meta: { title: '村级驳回待审' + '-' + sysTitle } },
                { path: '/applyaudit1list', component: applyauditlist, meta: { title: '乡级待审核' + '-' + sysTitle } },
                { path: '/applyaudit2list', component: applyaudit2list, meta: { title: '乡级待提交' + '-' + sysTitle } },
                { path: '/applyaudit3list', component: applyaudit3list, meta: { title: '乡级待审核' + '-' + sysTitle } },
                { path: '/applyaudit4list', component: applyaudit4list, meta: { title: '乡级驳回待审' + '-' + sysTitle } },
                { path: '/applyaudit5list', component: applyaudit5list, meta: { title: '区级待审核' + '-' + sysTitle } },
                { path: '/applyaudit6list', component: applyaudit6list, meta: { title: '区级待提交' + '-' + sysTitle } },
                { path: '/applyaudit7list', component: applyaudit7list, meta: { title: '区级待审核' + '-' + sysTitle } },
                { path: '/applyaudit8list', component: applyaudit8list, meta: { title: '区级驳回待审' + '-' + sysTitle } },
                // { path: '/applyauditfinishuserlist', component: applyaudit9list, meta: { title: '申报完成' + '-' + sysTitle } },
                { path: '/applyauditfailedlist', component: applyauditfailedlist, meta: { title: '申报未通过' + '-' + sysTitle } },
                // { path: '/rewardannualreviewuserlist', component: carefulreview, meta: { title: '年审审核' + '-' + sysTitle } },
                // { path: '/rewardannualreviewfaileduserlist', component: iscarefulreview, meta: { title: '年审未通过' + '-' + sysTitle } },
                // { path: '/rewardrecordinfolist', component: awardObjectFile, meta: { title: '奖扶对象档案' + '-' + sysTitle } },
                // { path: '/logoutrewardrecordinfolist', component: exitObjectFileList, meta: { title: '退出对象档案' + '-' + sysTitle } },
                // { path: '/moveoutrewardrecordinfolist', component: emigrationlist, meta: { title: '迁出管理' + '-' + sysTitle } },
                // { path: '/moveinrewardrecordinfolist', component: immigrationlist, meta: { title: '迁入管理' + '-' + sysTitle } },
                // { path: '/queryrewardauditlist', component: annuallist, meta: { title: '年审审核查询' + '-' + sysTitle } },
                // { path: '/queryrewardrecordinfolist', component: awardobject, meta: { title: '奖扶对象名单查询' + '-' + sysTitle } },
                // { path: '/queryapplyauditlist', component: declarelist, meta: { title: '申报审核查询' + '-' + sysTitle } },
                // { path: '/queryrewardlogoutlist', component: exitobjectlist, meta: { title: '退出对象名单查询' + '-' + sysTitle } },
                { path: '/querypolicymeasureinfolist', component: policymeasurelist, meta: { title: '政策措施汇编查询' + '-' + sysTitle } },
                { path: '/welcomenoticelist', component: welcomenoticelist, meta: { title: '公告查询' + '-' + sysTitle } },
                { path: '/advertinfolist', component: advertising, meta: { title: '广告管理' + '-' + sysTitle } },
                { path: '/userlist', component: userlist, meta: { title: '普通用户管理' + '-' + sysTitle } },
                { path: '/statisticsvillagerewardinfolist', component: statisticsvillagerewardinfolist, meta: { title: '奖扶报表' + '-' + sysTitle } },
                { path: '/statisticsvillagerewarddetailslist', component: statisticsvillagerewarddetailslist, meta: { title: '农村奖扶对象新增及退出统计表' + '-' + sysTitle } },
                { path: '/statisticstownrewardinfoexitlist', component: statisticstownrewardinfoexitlist, meta: { title: '城镇奖扶退出情况汇总统计表' + '-' + sysTitle } },
                { path: '/statisticstownrewardinfopeoplelist', component: statisticstownrewardinfopeoplelist, meta: { title: '城镇奖扶人数汇总统计表' + '-' + sysTitle } },
                { path: '/statisticsspecialassistanceinfolist', component: statisticsspecialassistanceinfolist, meta: { title: '特扶对象实施情况统计表' + '-' + sysTitle } },
                { path: '/statisticsspecialassistanceinforenewlist', component: statisticsspecialassistanceinforenewlist, meta: { title: '特扶对象本年新增及退出统计表' + '-' + sysTitle } },
                //新城镇奖扶 
                { path: '/applyauditvillage2userlist003', component: TownApplyAuditUserList, meta: { title: '公示' + '-' + sysTitle } },
                { path: '/moveoutrewardrecordinfolist003', component: townmoveoutrewardrecordinfolist, meta: { title: '迁出管理' + '-' + sysTitle } },

                //城镇奖扶
                { path: '/acceptapplylist003', component: townacceptapplylist, meta: { title: '受理登记' + '-' + sysTitle } },
                // { path: '/addpolicydeclarationinfo003', component: townaddpolicydeclarationinfo, meta: { title: '受理登记' + '-' + sysTitle } },
                { path: '/applyauditfaileduserlist003', component: townapplyauditfaileduserlist, meta: { title: '申报未通过' + '-' + sysTitle } },
                { path: '/applyauditvillage1userlist003', component: townapplyauditvillage1userlist, meta: { title: '村级待审核' + '-' + sysTitle } },
                { path: '/applyaudit1userlist003', component: townapplyaudit1userlist003, meta: { title: '乡级待审核' + '-' + sysTitle } },
                // { path: '/applyauditvillage2userlist003', component: townapplyauditvillage2userlist, meta: { title: '村级待公示' + '-' + sysTitle } },
                { path: '/rewardrecordinfolist003', component: townrewardrecordinfolist, meta: { title: '扶助对象管理' + '-' + sysTitle } },
                { path: '/logoutrewardrecordinfolist003', component: townlogoutrewardrecordinfolist, meta: { title: '退出对象管理' + '-' + sysTitle } },
                // { path: '/moveoutrewardrecordinfolist003', component: townmoveoutrewardrecordinfolist, meta: { title: '迁出管理' + '-' + sysTitle } },
                { path: '/moveinrewardrecordinfolist003', component: townmoveinrewardrecordinfolist, meta: { title: '迁入管理' + '-' + sysTitle } },
                { path: '/rewardannualreviewuserlist003', component: townrewarannualreviewuserlist, meta: { title: '年审审核' + '-' + sysTitle } },
                { path: '/applyauditfinishuserlist003', component: townapplyauditfinishuserlist, meta: { title: '已完成' + '-' + sysTitle } },
                { path: '/queryapplyauditlist003', component: townqueryapplyauditlist, meta: { title: '申报审核查询' + '-' + sysTitle } },
                { path: '/queryrewardauditlist003', component: townqueryrewardauditlist, meta: { title: '申报审核查询' + '-' + sysTitle } },
                { path: '/queryrewardrecordinfolist003', component: townqueryrewardrecordinfolist, meta: { title: '扶助对象查询' + '-' + sysTitle } },
                { path: '/queryrewardlogoutlist003', component: townQueryrewardlogoutlist, meta: { title: '退出对象查询' + '-' + sysTitle } },
                { path: '/moveoutqueryrecord003', component: TownMoveOutQueryRecordList, meta: { title: '迁出查询' + '-' + sysTitle } },
                //国家特扶
                { path: '/acceptapplylist002', component: nationacceptapplylist, meta: { title: '受理登记' + '-' + sysTitle } },
                // { path: '/addpolicydeclarationinfo002', component: nationaddpolicydeclarationinfo, meta: { title: '受理登记' + '-' + sysTitle } },
                { path: '/queryapplyauditlist002', component: nationqueryapplyauditlist, meta: { title: '申报审核查询' + '-' + sysTitle } },
                { path: '/queryrewardauditlist002', component: nationqueryrewardauditlist, meta: { title: '年审审核查询' + '-' + sysTitle } },
                { path: '/queryrewardlogoutlist002', component: nationqueryrewardlogoutlist, meta: { title: '退出对象查询' + '-' + sysTitle } },
                { path: '/queryrewardrecordinfolist002', component: nationqueryrewardrecordinfolist, meta: { title: '扶助对象查询' + '-' + sysTitle } },
                { path: '/applyauditfaileduserlist002', component: nationapplyauditfaileduserlist, meta: { title: '申报未通过' + '-' + sysTitle } },
                { path: '/applyauditvillage1userlist002', component: nationapplyauditvillage1userlist, meta: { title: '村级待审核' + '-' + sysTitle } },
                { path: '/applyauditvillage2userlist002', component: NationApplyAuditUserList, meta: { title: '公示' + '-' + sysTitle } },
                { path: '/applyauditvillage3userlist002', component: nationapplyauditvillage3userlist, meta: { title: '村级待审核' + '-' + sysTitle } },
                { path: '/applyauditvillage4userlist002', component: nationapplyauditvillage4userlist, meta: { title: '村级驳回待审' + '-' + sysTitle } },
                { path: '/applyaudit1userlist002', component: nationapplyaudit1userlist, meta: { title: '乡级待审核' + '-' + sysTitle } },
                { path: '/applyaudit2userlist002', component: nationapplyaudit2userlist, meta: { title: '乡级待公示' + '-' + sysTitle } },
                { path: '/applyaudit3userlist002', component: nationapplyaudit3userlist, meta: { title: '乡级待审核' + '-' + sysTitle } },
                { path: '/applyaudit4userlist002', component: nationapplyaudit4userlist, meta: { title: '乡级驳回待审' + '-' + sysTitle } },
                { path: '/applyaudit5userlist002', component: nationapplyaudit5userlist, meta: { title: '区级待审核' + '-' + sysTitle } },
                { path: '/applyaudit6userlist002', component: nationapplyaudit6userlist, meta: { title: '区级待公示' + '-' + sysTitle } },
                { path: '/applyaudit7userlist002', component: nationapplyaudit7userlist, meta: { title: '区级待审核' + '-' + sysTitle } },
                { path: '/applyaudit8userlist002', component: nationapplyaudit8userlist, meta: { title: '区级驳回待审' + '-' + sysTitle } },
                { path: '/applyauditfinishuserlist002', component: nationapplyauditfinishuserlist, meta: { title: '已完成' + '-' + sysTitle } },
                { path: '/rewardannualreviewuserlist002', component: nationrewardannualreviewuserlist, meta: { title: '年审审核' + '-' + sysTitle } },
                { path: '/rewardannualreviewfaileduserlist002', component: nationrewardannualreviewfaileduserlist, meta: { title: '年审未通过' + '-' + sysTitle } },
                { path: '/rewardrecordinfolist002', component: nationrewardrecordinfolist, meta: { title: '扶助对象管理' + '-' + sysTitle } },
                { path: '/logoutrewardrecordinfolist002', component: nationlogoutrewardrecordinfolist, meta: { title: '退出对象管理' + '-' + sysTitle } },
                { path: '/moveoutrewardrecordinfolist002', component: nationmoveoutrewardrecordinfolist, meta: { title: '迁出管理' + '-' + sysTitle } },
                { path: '/moveinrewardrecordinfolist002', component: nationmoveinrewardrecordinfolist, meta: { title: '迁入管理' + '-' + sysTitle } },
                //国家奖励扶助 nationawardAcceptApplyList
                { path: '/acceptapplylist', component: nationawardAcceptApplyList, meta: { title: '受理登记' + '-' + sysTitle } },
                { path: '/applyauditvillage2userlist', component: NationAwardApplyAuditUserList, meta: { title: '公示' + '-' + sysTitle } },
                { path: '/moveoutrewardrecordinfolist', component: nationawardmoveoutrewardrecordinfolist, meta: { title: '迁出管理' + '-' + sysTitle } },
                { path: '/moveinrewardrecordinfolist', component: nationawardmoveinrewardrecordinfolist, meta: { title: '迁入管理' + '-' + sysTitle } },


                // { path: '/addpolicydeclarationinfo', component: nationawardaddpolicydeclarationinfo, meta: { title: '受理登记' + '-' + sysTitle } },
                { path: '/applyauditvillage1userlist', component: nationawardapplyauditvillage1userlist, meta: { title: '村级待审核' + '-' + sysTitle } },
                { path: '/applyauditfaileduserlist', component: nationawardapplyauditfaileduserlist, meta: { title: '申报未通过' + '-' + sysTitle } },
               
                { path: '/applyauditvillage3userlist', component: nationawardapplyauditvillage3userlist, meta: { title: '村级待审核' + '-' + sysTitle } },
                { path: '/applyauditvillage4userlist', component: nationawardapplyauditvillage4userlist, meta: { title: '村级驳回待审' + '-' + sysTitle } },
                { path: '/applyaudit1userlist', component: nationawardapplyaudit1userlist, meta: { title: '乡级待审核' + '-' + sysTitle } },
                { path: '/applyaudit2userlist', component: nationawardapplyaudit2userlist, meta: { title: '乡级待公示' + '-' + sysTitle } },
                { path: '/applyaudit3userlist', component: nationawardapplyaudit3userlist, meta: { title: '乡级待审核' + '-' + sysTitle } },
                { path: '/applyaudit4userlist', component: nationawardapplyaudit4userlist, meta: { title: '乡级驳回待审' + '-' + sysTitle } },
                { path: '/applyaudit5userlist', component: nationawardapplyaudit5userlist, meta: { title: '区级待审核' + '-' + sysTitle } },
                { path: '/applyaudit6userlist', component: nationawardapplyaudit6userlist, meta: { title: '区级待公示' + '-' + sysTitle } },
                { path: '/applyaudit7userlist', component: nationawardapplyaudit7userlist, meta: { title: '区级待审核' + '-' + sysTitle } },
                { path: '/applyaudit8userlist', component: nationawardapplyaudit8userlist, meta: { title: '区级驳回待审' + '-' + sysTitle } },
                { path: '/applyauditfinishuserlist', component: nationawardapplyauditfinishuserlist, meta: { title: '已完成' + '-' + sysTitle } },
                // { path: '/queryapplyauditlist', component: nationawardqueryapplyauditlist, meta: { title: '申报审核查询' + '-' + sysTitle } },
                // { path: '/queryrewardauditlist', component: nationawardqueryrewardauditlist, meta: { title: '年审审核查询' + '-' + sysTitle } },
                { path: '/queryrewardlogoutlist', component: nationawardqueryrewardlogoutlist, meta: { title: '退出对象查询' + '-' + sysTitle } },
                // { path: '/queryrewardrecordinfolist', component: nationawardqueryrewardrecordinfolist, meta: { title: '扶助对象查询' + '-' + sysTitle } },
                { path: '/rewardrecordinfolist', component: nationawardrewardrecordinfolist, meta: { title: '扶助对象管理' + '-' + sysTitle } },
                { path: '/logoutrewardrecordinfolist', component: nationawardlogoutrewardrecordinfolist, meta: { title: '退出对象管理' + '-' + sysTitle } },
                { path: '/rewardannualreviewuserlist', component: nationawardrewardannualreviewuserlist, meta: { title: '年审审核' + '-' + sysTitle } },
                { path: '/rewardannualreviewfaileduserlist', component: nationawardrewardannualreviewfaileduserlist, meta: { title: '年审未通过' + '-' + sysTitle } },

                //信息查询
                { path: '/queryrewardauditlist', component: QueryRewardAuditList, meta: { title: '年审审核查询' + '-' + sysTitle } },
                { path: '/queryrewardrecordinfolist', component: QueryRewardRecordInfoList, meta: { title: '扶助对象查询' + '-' + sysTitle } },
                { path: '/queryapplyauditlist', component: QueryApplyAuditList, meta: { title: '申报审核查询' + '-' + sysTitle } },




                {
                    path: '/404',
                    component: notfound,
                    meta: { title: '你要请求的内容丢失了！' }
                }
            ]
        },
        {
            path: '/login',
            component: login,
            meta: { title: '登录' }
        },
        {
            path: '/home',
            component: home,
            meta: { title: '登录' }
        },
        {
            path: '*',
            component: notfound,
            meta: { title: '你要请求的内容丢失了！' },
            redirect: '/404'
        }

    ]
})

export default router

router.beforeEach((to, from, next) => {

    if (to.meta.title) {
        document.title = to.meta.title
    }

    NProgress.start()

    next()

})

router.afterEach(transition => {

    NProgress.done()

})